module.exports = __webpack_public_path__ + "static/media/3_col_7.1e8ee2f5.jpg";